module.exports = __webpack_public_path__ + "g.no1.292224bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/g.no1.jpg
// module id = TFx4
// module chunks = 0